import React, {useEffect, useState} from 'react';
import '../Components/userCard.css';

const Usercard = () => {
  const [User,setUser] = useState(null);

  async function getUser() {
    const response = await fetch("https://randomUser.me/api/");
    const data = await response.json();
    setUser(data.results[0]);
  }
  
  useEffect(() => {
    getUser();
  }, []); 

  if (!User) {
    return <div>Loading...</div>;
  }

  return (
    <div className="userCard">
      <>
        <div className='imagediv'>
        <img className='userImg' src={User.picture.medium} alt="User Avatar" />
        </div>
        <p>Full Name : {User.name?.title} {User.name?.first} {User.name?.last}</p>
        <p>Location : {User.location.city}, {User.location.state}, {User.location.country}</p>
        <p>Email : {User.email}</p>
        <p>Phone Number : {User.phone}</p>
        <p>Location : {User.email}</p>
        <p>Phone Number : {User.location.city}, {User.location.state}, {User.location.country}, {User.location.postcode}</p>
        <p></p>
        <button className='getUser' onClick={getUser}>Get User</button>  
      </>
    </div>
  )
}

export default Usercard;
